import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Homepage } from '@jbhi-fi/components/src/views/Homepage/Homepage';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import resolveResponse from 'contentful-resolve-response';
import { ShopifyProductCompareProvider } from '../contexts/ShopifyProductCompareContext';
import { ContentfulHomepage } from '@jbhi-fi/apis/src/contentful/types';
import { HomepagePropsProvider } from '@jbhi-fi/components/src/context/HomepagePropsProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';
import { getSalesLineHours } from '@jbhi-fi/components/src/ContactBlock/utils/salesLine/salesLine';
import { ContactBlock } from '@jbhi-fi/components/src/ContactBlock/ContactBlock';
import { LegacyContactBlock } from '@jbhi-fi/components/src/ContactBlock/LegacyContactBlock/LegacyContactBlock';

const getHomepageData = (): ContentfulHomepage | undefined => {
  try {
    const homepageData = resolveResponse(
      JSON.parse(decodeURIComponent(window?.Jbhifi?.homepageDataString ?? '') || '{}')
    );
    return homepageData?.[0];
  } catch (err) {
    console.error('Error parsing homepage data', err);
    return undefined;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('main-content');
  element?.classList?.remove('hidden');

  const homepageData = getHomepageData();
  if (!homepageData || !element) {
    drawDefaultLayout();
    return console.error('Could not read homepageData. Has a value been set?');
  }

  const root = createRoot(element);
  const contentfulImageQuality = window.Jbhifi.contentfulSettings?.homepageContentfulImageQuality;
  root.render(
    <BaseContentProvider
      shopifyProductActionsProviderProps={{ attachPageType: 'homepage' }}
      configProviderProps={{ contentfulImageQuality }}
    >
      <ShopifyProductCompareProvider shouldHideCompare>
        <HomepagePropsProvider
          disclaimers={window.Jbhifi.disclaimers}
          useInitialData={() => homepageData}
          salesLineHours={getSalesLineHours()}
          contactBlockComponent={window?.Jbhifi?.storeLocation === 'NZ' ? LegacyContactBlock : ContactBlock}
        >
          <DefaultLayout>
            <Homepage />
          </DefaultLayout>
        </HomepagePropsProvider>
      </ShopifyProductCompareProvider>
    </BaseContentProvider>
  );
});
